import { Messages } from '../../../../../gen-src/Localize';
import { assertUnreachable } from '../utils/TypescriptHelpers';

/**
 * @deprecated TFS-1478812
*/
export enum DataQualityType {
  WARNING,
  DEPRECATED,
  STALE,
  MAINTENANCE,
  SENSITIVE_DATA,
  EXTRACT_REFRESH_FAILURE,
  FLOW_RUN_FAILURE,
  CERTIFIED,
}

/**
 * @deprecated TFS-1478812
*/
export function stringToDataQualityType(type: string): DataQualityType {
  switch (type) {
    case DataQualityType[DataQualityType.WARNING]: return DataQualityType.WARNING;
    case DataQualityType[DataQualityType.DEPRECATED]: return DataQualityType.DEPRECATED;
    case DataQualityType[DataQualityType.STALE]: return DataQualityType.STALE;
    case DataQualityType[DataQualityType.MAINTENANCE]: return DataQualityType.MAINTENANCE;
    case DataQualityType[DataQualityType.SENSITIVE_DATA]: return DataQualityType.SENSITIVE_DATA;
    case DataQualityType[DataQualityType.EXTRACT_REFRESH_FAILURE]: return DataQualityType.EXTRACT_REFRESH_FAILURE;
    case DataQualityType[DataQualityType.FLOW_RUN_FAILURE]: return DataQualityType.FLOW_RUN_FAILURE;
    case DataQualityType[DataQualityType.CERTIFIED]: return DataQualityType.CERTIFIED;
    default: return DataQualityType.WARNING;
  }
}

/**
 * @deprecated TFS-1478812
*/
export function localizeDataQualityTypeName(type: DataQualityType): string {
  switch (type) {
    case DataQualityType.WARNING:
      return Messages.DataQualityTypeWarning();
    case DataQualityType.DEPRECATED:
      return Messages.DataQualityTypeDeprecated();
    case DataQualityType.STALE:
      return Messages.DataQualityTypeStale();
    case DataQualityType.MAINTENANCE:
      return Messages.DataQualityTypeMaintenance();
    case DataQualityType.SENSITIVE_DATA:
      return Messages.DataQualityTypeSensitiveData();
    case DataQualityType.EXTRACT_REFRESH_FAILURE:
      return Messages.DataQualityTypeExtractRefreshFailure();
    case DataQualityType.FLOW_RUN_FAILURE:
      return Messages.DataQualityTypeFlowRunFailure();
    case DataQualityType.CERTIFIED:
      return Messages.DataQualityTypeCertified();
    default:
      assertUnreachable(type);
      return '';
  }
}
